/*
  BrickOvenBaker collection grid + filters (sections/bob-collection-grid.liquid).
  Filters, sort, active-filter chips and "Show more" update the section in
  place through the Section Rendering API. Without this script the same
  controls work as normal links and a GET form.
  After "Show more", sold-out cards (.bob-avail-false) move back to the end
  of the grid when it has data-bob-soldout-last.
*/
(function () {
  if (customElements.get('bob-collection')) return;

  var KEEP = ['view', 'q', 'preview_theme_id'];

  function parseSection(html, id) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('bob-collection[data-section-id="' + id + '"]');
  }

  class BobCollection extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.sectionId = this.dataset.sectionId;
      this._onChange = this.onChange.bind(this);
      this._onClick = this.onClick.bind(this);
      this._onSubmit = this.onSubmit.bind(this);
      this._onKey = this.onKey.bind(this);
      this.addEventListener('change', this._onChange);
      this.addEventListener('click', this._onClick);
      this.addEventListener('submit', this._onSubmit);
      document.addEventListener('keydown', this._onKey);
      window.addEventListener('popstate', function () {
        this.load(location.href, false);
      }.bind(this));
    }

    /* ---------- URL from the form and sort ---------- */
    buildUrl() {
      var current = new URL(location.href);
      var params = new URLSearchParams();
      KEEP.forEach(function (k) {
        if (current.searchParams.has(k)) params.set(k, current.searchParams.get(k));
      });
      var form = this.querySelector('[data-bob-form]');
      if (form) {
        new FormData(form).forEach(function (value, key) {
          if (key === 'sort_by' || value === '') return;
          params.append(key, value);
        });
      }
      var sort = this.querySelector('[data-bob-sort]');
      var sortValue = sort ? sort.value : (current.searchParams.get('sort_by') || '');
      if (sortValue) params.set('sort_by', sortValue);
      var qs = params.toString();
      return location.pathname + (qs ? '?' + qs : '');
    }

    withKeptParams(href) {
      var url = new URL(href, location.href);
      var current = new URL(location.href);
      KEEP.forEach(function (k) {
        if (current.searchParams.has(k) && !url.searchParams.has(k)) url.searchParams.set(k, current.searchParams.get(k));
      });
      return url.pathname + url.search;
    }

    sectionUrl(href) {
      var url = new URL(href, location.href);
      url.searchParams.set('section_id', this.sectionId);
      return url.pathname + url.search;
    }

    /* ---------- Events ---------- */
    onChange(event) {
      var t = event.target;
      if (t.matches('[data-bob-sort]')) {
        this.load(this.buildUrl(), true);
        return;
      }
      if (t.closest('[data-bob-form]')) {
        clearTimeout(this._t);
        this._t = setTimeout(function () {
          this.load(this.buildUrl(), true);
        }.bind(this), t.type === 'number' ? 0 : 120);
      }
    }

    onSubmit(event) {
      if (!event.target.matches('[data-bob-form]')) return;
      event.preventDefault();
      this.load(this.buildUrl(), true);
    }

    onClick(event) {
      var t = event.target;
      var link = t.closest('[data-bob-link]');
      if (link && this.contains(link)) {
        event.preventDefault();
        this.load(this.withKeptParams(link.href), true);
        return;
      }
      var more = t.closest('[data-bob-more]');
      if (more) {
        event.preventDefault();
        this.loadMore(more);
        return;
      }
      if (t.closest('[data-bob-open]')) {
        this.openPanel();
        return;
      }
      if (t.closest('[data-bob-close]')) {
        this.closePanel();
        return;
      }
      var all = t.closest('[data-bob-all]');
      if (all) {
        var group = all.closest('.bob-fg');
        if (group) group.classList.toggle('is-all');
      }
    }

    onKey(event) {
      if (event.key === 'Escape' && this.classList.contains('is-open')) this.closePanel();
    }

    /* ---------- Phone filter sheet ---------- */
    openPanel() {
      this.classList.add('is-open');
      document.documentElement.classList.add('bob-coll-lock');
      var btn = this.querySelector('[data-bob-open]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      var x = this.querySelector('.bob-coll__x');
      if (x) x.focus({ preventScroll: true });
    }

    closePanel() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('bob-coll-lock');
      var btn = this.querySelector('[data-bob-open]');
      if (btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.focus({ preventScroll: true });
      }
    }

    /* ---------- Load a filtered / sorted view ---------- */
    load(url, push) {
      var token = (this._token || 0) + 1;
      this._token = token;
      this.classList.add('is-loading');
      fetch(this.sectionUrl(url), { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          if (token !== this._token) return;
          var fresh = parseSection(html, this.sectionId);
          if (!fresh) throw new Error('section missing');
          this.swap(fresh);
          if (push) history.pushState({ bobCollection: true }, '', url);
          this.classList.remove('is-loading');
        }.bind(this))
        .catch(function () {
          location.href = url;
        });
    }

    swap(fresh) {
      // Results: bar, active chips, grid, more, bottom banners
      var results = this.querySelector('[data-bob-results]');
      var freshResults = fresh.querySelector('[data-bob-results]');
      if (results && freshResults) {
        results.innerHTML = freshResults.innerHTML;
        var btn = results.querySelector('[data-bob-open]');
        if (btn) btn.setAttribute('aria-expanded', this.classList.contains('is-open') ? 'true' : 'false');
      }

      // Filter groups: keep which groups are open / expanded and the scroll
      var groups = this.querySelector('[data-bob-groups]');
      var freshGroups = fresh.querySelector('[data-bob-groups]');
      if (groups && freshGroups) {
        var state = {};
        groups.querySelectorAll('.bob-fg').forEach(function (g) {
          state[g.dataset.key] = { open: g.open, all: g.classList.contains('is-all') };
        });
        var scroller = this.querySelector('.bob-coll__form');
        var top = scroller ? scroller.scrollTop : 0;
        groups.innerHTML = freshGroups.innerHTML;
        groups.querySelectorAll('.bob-fg').forEach(function (g) {
          var st = state[g.dataset.key];
          if (!st) return;
          if (st.open) g.open = true;
          if (st.all) g.classList.add('is-all');
        });
        if (scroller) scroller.scrollTop = top;
      }

      [['[data-bob-clear]'], ['[data-bob-show]']].forEach(function (sel) {
        var a = this.querySelector(sel[0]);
        var b = fresh.querySelector(sel[0]);
        if (a && b) a.innerHTML = b.innerHTML;
      }, this);

      var sortInput = this.querySelector('[data-bob-form] input[name="sort_by"]');
      var sort = this.querySelector('[data-bob-sort]');
      if (sortInput && sort) sortInput.value = sort.value;
    }

    /* ---------- Show more ---------- */
    loadMore(link) {
      if (link.classList.contains('is-busy')) return;
      link.classList.add('is-busy');
      fetch(this.sectionUrl(this.withKeptParams(link.href)), { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var fresh = parseSection(html, this.sectionId);
          if (!fresh) throw new Error('section missing');
          var grids = this.querySelectorAll('[data-bob-grid]');
          var grid = grids[grids.length - 1];
          var freshGrid = fresh.querySelector('[data-bob-grid]');
          if (grid && freshGrid) {
            var added = Array.prototype.slice.call(freshGrid.children);
            added.forEach(function (el) {
              grid.appendChild(el);
            });
            if (grid.hasAttribute('data-bob-soldout-last')) {
              // Keep sold-out cards after every in-stock card loaded so far
              Array.prototype.slice.call(grid.children).forEach(function (el) {
                if (el.classList.contains('bob-avail-false')) grid.appendChild(el);
              });
            }
            var firstNew = null;
            added.some(function (el) {
              if (el.classList.contains('bob-avail-false')) return false;
              firstNew = el;
              return true;
            });
            if (!firstNew) firstNew = added[0] || null;
            var focusable = firstNew && firstNew.querySelector('a[href]:not([tabindex="-1"])');
            if (focusable) focusable.focus({ preventScroll: true });
          }
          var wrap = this.querySelector('[data-bob-more-wrap]');
          var freshWrap = fresh.querySelector('[data-bob-more-wrap]');
          if (wrap) wrap.innerHTML = freshWrap ? freshWrap.innerHTML : '';
        }.bind(this))
        .catch(function () {
          location.href = link.href;
        });
    }
  }

  customElements.define('bob-collection', BobCollection);
})();
